import { render, staticRenderFns } from "./ServiceTerm.vue?vue&type=template&id=85c8379c&scoped=true&"
import script from "./ServiceTerm.vue?vue&type=script&lang=js&"
export * from "./ServiceTerm.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTerm.vue?vue&type=style&index=0&id=85c8379c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c8379c",
  null
  
)

export default component.exports